<template>
  <div>
    <div class="row justify-content-between py-2" style="font-size: 10pt;">
      <div :style="'padding-left:' + (20 * (level)) + 'px'" class="col-7 text-left" style="word-break: break-all">
        <div v-if="hasChildren">
          <span class="d-inline-block font-weight-bold">
            <font-awesome-icon :icon="!expanded ? 'folder' : 'folder-open'" class="text-warning"
              @click="expanded = !expanded" />
            <!--            {{ prefix.length <= 1 ? prefix[0] : prefix.join('.') }}-->
          </span>
          <div v-if="node.hasAttachment" class="ml-3 d-inline-block">
            <a v-if="node.circular_issue_id !== 5" :title="node.subject" class="text-dark" data-placement="top"
              role="button" @click="viewCircularFile(node)">
              <font-awesome-icon :class="{
                'text-danger': node.fileType === 'PDF',
                'text-success': node.fileType === 'EXCEL',
                'text-primary': node.fileType === 'WORD',
              }" :icon="node.fileType === 'PDF' ? 'file-pdf' :
                node.fileType === 'EXCEL' ? 'file-excel' :
                  node.fileType === 'WORD' ? 'file-word' : ''" />
              {{ node.subject }}
            </a>
            <a v-else :title="node.subject" class="text-dark" data-placement="top" role="button"
              @click="$router.push({ name: 'ViewFile', params: { type: 'circular', id: node.id } })">
              {{ node.subject }}
            </a>
          </div>
          <div v-else class="ml-3 d-inline-block">
            {{ node.subject }}
          </div>
        </div>
        <div v-else>
          <span class="d-inline-block font-weight-bold">
            <!--            {{ prefix.length <= 1 ? prefix[0] : prefix.join('.') }}-->
          </span>
          <div v-if="node.hasAttachment" class="ml-3 d-inline">
            <a v-if="node.circular_issue_id !== 5" :title="node.subject" class="text-dark" data-placement="top"
              role="button" @click="viewCircularFile(node)">
              <font-awesome-icon :class="{
                'text-danger': node.fileType === 'PDF',
                'text-success': node.fileType === 'EXCEL',
                'text-primary': node.fileType === 'WORD',
              }" :icon="node.fileType === 'PDF' ? 'file-pdf' :
                node.fileType === 'EXCEL' ? 'file-excel' :
                  node.fileType === 'WORD' ? 'file-word' : ''" />

              {{ node.subject }}
            </a>
            <a v-else :title="node.subject" class="text-dark" data-placement="top" role="button"
              @click="viewCircularFile(node)">
              {{ node.subject }}
            </a>
          </div>
          <div v-else class="ml-3 d-inline">
            {{ node.subject }}
          </div>
        </div>
        <div v-for="(attachment, index) in node.circular_attachments"
          :class="node.circular_issue_id === 4 ? '' : 'd-inline-block'" class="ml-5 dropdown d-block mb-1">
          <template v-if="attachment.hasAttachment">
            <button v-if="isStaff" id="attachmentDropdown" aria-expanded="false" aria-haspopup="true"
              class="btn badge d-block mr-2" :class="{
                'badge-danger': attachment.fileType === 'PDF',
                'badge-success': attachment.fileType === 'EXCEL',
                'badge-primary': attachment.fileType === 'WORD',
              }" data-toggle="dropdown" data-tooltip="tooltip" data-placement="right"
              :title="attachment.date !== '0000-00-00' ? 'Date: ' + attachment.date : 'No Date'">
              <font-awesome-icon class="mr-2" :icon="attachment.fileType === 'PDF' ? 'file-pdf' :
                attachment.fileType === 'EXCEL' ? 'file-excel' :
                  attachment.fileType === 'WORD' ? 'file-word' : ''"></font-awesome-icon>
              {{ attachment.attachment_name }}
            </button>
            <button v-else class="btn badge badge-danger mr-2 d-block" role="button"
              @click="viewCircularAttachmentFile(attachment)">
              <font-awesome-icon class="mr-2" icon="file-pdf"></font-awesome-icon>
              {{ attachment.attachment_name }}
            </button>
            <div aria-labelledby="attachmentDropdown" class="dropdown-menu">
              <button v-if="node.circular_issue_id === 5" class="dropdown-item text-primary font-weight-bolder"
                type="button" @click="viewCircularAttachmentFile(attachment)">
                <font-awesome-icon class="ml-2 mr-1" icon="eye" />
                View Attachment
              </button>
              <button v-else class="dropdown-item text-primary font-weight-bolder" type="button"
                @click="viewCircularAttachmentFile(attachment)">
                <font-awesome-icon class="ml-2 mr-1" icon="eye" />
                View Attachment
              </button>
              <button class="dropdown-item text-warning font-weight-bolder" type="button"
                v-if="isPrincipalStaff || isPrincipalAdmin || isPrincipal || isSystemAdmin"
                @click="$emit('editAttachmentInfo', { attachment: { ...attachment }, circular: { ...node } })">
                <font-awesome-icon class="ml-2 mr-1" icon="pencil" />
                Edit Attachment
              </button>
              <button class="dropdown-item text-danger font-weight-bolder" type="button"
                v-if="isPrincipalStaff || isPrincipalAdmin || isPrincipal || isSystemAdmin"
                @click="confirmDeleteAttachment(attachment)">
                <font-awesome-icon class="ml-2 mr-1" icon="trash" />
                Delete Attachment
              </button>
            </div>
          </template>
          <template v-else>
            <button class="btn badge badge-danger mr-2 d-block" type="button" data-toggle="tooltip" data-placement="top"
              title="No File" disabled>
              <font-awesome-icon class="mr-2" icon="file-pdf"></font-awesome-icon>
              {{ attachment.attachment_name }}
            </button>
          </template>
        </div>
      </div>
      <div class="col-2" style="word-wrap: break-word">
        {{ node.letter_no }}
      </div>
      <div class="col-1" style="white-space: nowrap">
        {{ dateEliteFormat(node.date) }}
      </div>
      <div :title="node.circular_category" class="col-1" style="white-space: nowrap">
        {{ node.hasAttachment ? node.circular_code : '' }}
      </div>
      <div class="col-1" style="white-space: nowrap">
        <div class="dropdown dropleft">
          <button id="userDetailsDropdown" aria-expanded="false" aria-haspopup="true"
            class="btn btn-sm text-sm btn-dark dropdown-toggle font-weight-bolder " data-toggle="dropdown"
            :disabled="!(node.hasAttachment || hasCircularAttachmentsFiles(node))"
            v-if="(!isPrincipal && !isPrincipalStaff && !isPrincipalAdmin && !isSystemAdmin)" type="button">
            Action
          </button>
          <button id="userDetailsDropdown" v-else aria-expanded="false" aria-haspopup="true"
            class="btn btn-sm text-sm btn-dark dropdown-toggle font-weight-bolder " data-toggle="dropdown"
            type="button">
            Action
          </button>
          <div aria-labelledby="userDetailsDropdown" class="dropdown-menu">
            <button v-if="node.hasAttachment" class="btn btn-outline-primary sm w-100 my-1 border-0 text-left"
              type="button" @click="viewCircularFile(node)">
              <font-awesome-icon icon="eye" />
              <span class="ml-1">View</span>
            </button>

            <hr v-if="node.hasAttachment" class="m-0" />

            <button v-show="isStaff && (isPrincipal || isPrincipalAdmin || isPrincipalStaff || isSystemAdmin)"
              class="btn btn-outline-warning sm w-100 my-1 border-0 text-left" type="button"
              @click="editCircular(node)">
              <font-awesome-icon icon="pencil" />
              <span class="ml-1">Edit</span>
            </button>

            <hr class="m-0" />

            <button class="btn btn-outline-primary sm w-100 my-1 border-0 text-left"
              v-show="isStaff && (isPrincipal || isPrincipalAdmin || isPrincipalStaff || isSystemAdmin)"
              data-target="#add-circular-attachment" data-toggle="modal" type="button"
              @click="SET_SELECTED_CIRCULAR(node)">
              <font-awesome-icon icon="plus" />
              <span class="ml-1">Add Attachment</span>
            </button>

            <hr class="m-0" />
            <button v-show="isStaff && (isPrincipal || isPrincipalAdmin || isPrincipalStaff || isSystemAdmin)"
              class="btn btn-outline-primary sm w-100 my-1 border-0 text-left" data-target="#add-letter_no"
              data-toggle="modal" type="button" @click="addLetterNo(node)">
              <font-awesome-icon icon="file-circle-plus" />
              <span class="ml-1">Add Letter No.</span>
            </button>

            <hr v-if="node.hasAttachment" class="m-0" />
            <button v-if="node.hasAttachment" class="btn btn-outline-success sm w-100 my-1 border-0 text-left"
              type="button" @click="downloadFile(node.id)">
              <font-awesome-icon icon="file-download" />
              <span class="ml-1">Download</span>
            </button>

            <hr v-if="node.hasAttachment || hasCircularAttachmentsFiles(node)" class="m-0" />
            <button v-if="node.hasAttachment || hasCircularAttachmentsFiles(node)"
              class="btn btn-outline-success sm w-100 my-1 border-0 text-left" type="button"
              @click="downloadFile(node.id, 'zip')">
              <font-awesome-icon icon="file-zipper" />
              <span class="ml-1">Download as .zip</span>
            </button>

            <hr class="m-0" />
            <button v-show="isStaff && (isPrincipal || isPrincipalAdmin || isPrincipalStaff || isSystemAdmin)"
              class="btn btn-outline-danger sm w-100 my-1 border-0 text-left" type="button"
              @click="confirmDeleteCircular(node)">
              <font-awesome-icon icon="file-zipper" />
              <span class="ml-1">Delete</span>
            </button>


          </div>
        </div>
      </div>
    </div>
    <div v-if="hasChildren && expanded">
      <custom-table-tree v-for="(node, index) in node.circulars" :key="node.id" :index="index + 1" :level="level + 1"
        :node="node" :prefix="generatePrefixes(index + 1)" @addLetter="(node) => $emit('addLetter', node)"
        @deletedCircular="(node) => $emit('deletedCircular', node)"
        @editAttachmentInfo="$emit('editAttachmentInfo', $event)"
        @editCircularInfo="(node) => $emit('editCircularInfo', node)">
      </custom-table-tree>
    </div>
    <div v-else-if="hasChildren && expanded">
      <custom-table-tree v-for="(node, index) in node.circulars" :key="node.id" :index="index + 1" :level="level + 1"
        :node="node" :prefix="generatePrefixes(index + 1)" @addLetter="(node) => $emit('addLetter', node)"
        @deletedCircular="(node) => $emit('deletedCircular', node)"
        @editAttachmentInfo="$emit('editAttachmentInfo', $event)"
        @editCircularInfo="(node) => $emit('editCircularInfo', node)">
      </custom-table-tree>
    </div>
    <base-modal id="add-circular-attachment" :title="'ADD ATTACHMENT'" @resetField="resetUploadAttachment">
      <template #modal-form>
        <div class="modal-body">
          <div class="form-group row">
            <label class="col-2 col-form-label text-left" for="attachments">Subject</label>
            <div class="col-10">
              <input :value="selected_circular.subject" class="form-control form-control-sm" disabled type="text">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 col-form-label text-left" for="attachments">Choose File</label>
            <div class="col-10">
              <input id="attachments" ref="attachments" :accept="[
                '.doc',
                '.docx',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/pdf',
                '.xls',
                '.xlsx',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel.sheet.macroEnabled.12',
                'application/vnd.sealed.eml',
                'message/rfc822',
                'application/octet-stream',
                '.zip',
                'application/zip',
                'application/x-zip-compressed',
                'image/apng',
                'image/avif',
                'image/gif',
                'image/jpeg',
                'image/png',
                'image/svg+xml',
                'image/webp',
                'application/vnd.ms-powerpoint',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
              ].join(',')" class="form-control" name="attachment" required type="file" @change="changeAttachment">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 col-form-label text-left" for="date-add">Date</label>
            <div class="col-10">
              <input id="date-add" v-model="uploadCircularAttachment.date" class="form-control" type="date">
            </div>
          </div>
          <div class="text-right">
            <button class="btn btn-sm btn-success" @click.prevent="confirmAddAttachment">
              <font-awesome-icon class="mr-2" icon="file-upload" />
              UPLOAD ATTACHMENT
            </button>
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>
<script>
import CustomSelect from '@/components/CustomSelect';
import SelectCircular from '@/components/SelectCircular';
import BaseModal from '@/components/base/BaseModal';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { AlertService } from '@/service/alert.service';
import { AppService } from '@/service/app.service';
import { FileService } from '@/service/file.service';
import { UacMixins } from '@/mixins/uac.mixins';

export default {
  name: 'CustomTableTree',
  components: { BaseModal, SelectCircular, CustomSelect },
  mixins: [UacMixins],
  props: {
    node: {
      type: Object,
      default: null,
    },
    level: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
    prefix: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      uploadCircularAttachment: {
        date: '',
      },
      attachment: '',
      prefixes: [],
      expanded: false,
    };
  },
  mounted() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    $(document).ready(function () {
      $('body').tooltip({
        selector: "[data-tooltip=tooltip]",
        container: "body"
      });
    });


  },
  computed: {
    ...mapGetters([
      'selected_circular',
      'circular_categories',
      'authUser',
      'crewPagination',
    ]),
    hasChildren() {
      return (this.node.circulars.length > 0);
    },
  },
  methods: {
    ...mapMutations(
      [
        'SET_SELECTED_CIRCULAR',
      ],
    ),
    ...mapActions([
      'addAttachment',
      'getCircularFile',
      'getCircularAttachmentFile',
      'getZipFile',
      'deleteCircularAttachment',
      'deleteCircular',
      'addCircular',
    ]),

    generatePrefixes(prefix) {
      let prefixes = Object.assign([], this.prefix);
      prefixes.push(prefix);
      return prefixes;
    },

    async confirmDeleteCircular(circular) {
      if (await AlertService.questionAlertService(
        `You are deleting this circular
                 <p style="white-space:break-spaces" class="mb-0"><b>${circular.subject}</b></p>
                 <p class="text-center mt-0">do you want to proceed?</p>
                `,
        'DELETE CIRCULAR', 'question')
      ) {
        let response = await this.deleteCircular(circular);
        if (response) {
          AlertService.successAlertService('Circular deleted successfully', 'DELETE ATTACHMENT');
          this.$emit('deletedCircular', circular);
        }
      }
    },
    resetUploadAttachment() {
      this.$refs.attachments.value = null;
      this.uploadCircularAttachment.date = null;
    },
    changeAttachment(event) {
      this.attachment = event.target.files[0];
    },
    async viewCircularFile(circular) {
      const pdfView = [
        "SMS HANDBOOK",
        "SMS UPDATES"
      ]

      // if (pdfView.includes(circular.circular_category) &&
      //   circular.fileType ===  "PDF"
      // ) {
      //   this.$router.push({
      //     name: 'ViewFile',
      //     params: {
      //       type:'circular',
      //       id:circular.id
      //     }
      //   })
      //   return
      // }

      const response = await this.getCircularFile(circular.id)

      if (response.errors) {
        return
      }

      if (circular.fileType === "PDF" && pdfView.includes(circular.circular_category)) {
        FileService.viewDocument(response.file, response.file_name)
        return
      }

      FileService.downloadDocument(response.file, response.file_name);
    },
    async confirmAddAttachment() {
      if (await AlertService.questionAlertService(
        `Do you want to add attachment on
                 <br>
                 <p style="white-space:break-spaces"><b>${this.selected_circular.subject}</b></p>
                 </br>`,
        'ADD ATTACHMENT', 'question')
      ) {
        let obj = {
          date: this.uploadCircularAttachment.date,
          circular_id: this.selected_circular.id,
          circular_issue_id: this.selected_circular.circular_issue_id,
        };
        let form = AppService.generateFormData(obj, this.attachment, 'attachments');
        let response = await this.addAttachment(form);
        if (!response.errors) {
          AlertService.successAlertService('Attachment added successfully', 'ADD ATTACHMENT');
          this.resetUploadAttachment();
          $('#add-circular-attachment').modal('hide');
        }
      }
    },
    async viewCircularAttachmentFile(circular_attachment) {
      if (this.node.circular_category === "SMS HANDBOOK" &&
        circular_attachment.fileType === "PDF"
      ) {
        this.$router.push({
          name: 'ViewFile',
          params: {
            type: 'circular_attachment',
            id: circular_attachment.id
          }
        })

        return
      }

      const response = await this.getCircularAttachmentFile(circular_attachment.id)

      if (response.errors) {
        return
      }

      if (response.file_type === "pdf") {
        FileService.viewDocument(response.file, response.file_name)
        return
      }

      FileService.downloadDocument(response.file, response.file_name);
    },
    async downloadFile(circular, $type) {
      swal.fire({
        title: 'GENERATING FILE',
      });
      swal.showLoading();
      let response = $type !== 'zip' ? await this.getCircularFile(circular) : await this.getZipFile(circular);
      if (!response.errors) {
        swal.close();
        FileService.downloadDocument(response.file, response.file_name);
      }
    },
    async confirmDeleteAttachment(circular_attachment) {
      if (await AlertService.questionAlertService(
        `Do you to delete
                 <br>
                 <p style="white-space:break-spaces"><b>${circular_attachment.attachment_name}</b></p>
                 </br>`,
        'DELETE CIRCULAR ATTACHMENT', 'question')
      ) {
        let response = await this.deleteCircularAttachment(circular_attachment.id);
        if (response) {
          AlertService.successAlertService('Attachment deleted successfully', 'DELETE ATTACHMENT');
        }
      }
    },
    async addLetterNo(node) {
      if (node) {
        this.$emit('addLetter', node);
      }
    },
    editCircular(node) {
      if (node) {
        this.$emit('editCircularInfo', node);
      }
    },
    dateEliteFormat(date) {
      return AppService.dateEliteFormat(date);
    },
    hasCircularAttachmentsFiles(item, visited = new Set()) {
      if (!item || visited.has(item)) return false;
      visited.add(item);

      if (item.hasAttachment === true) return true;

      if (Array.isArray(item.circular_attachments) && item.circular_attachments.length > 0) {
        if (item.circular_attachments.some(att => att.hasAttachment)) return true;
      }

      if (Array.isArray(item.circulars) && item.circulars.length > 0) {
        return item.circulars.some(childItem => this.hasCircularAttachmentsFiles(childItem, visited));
      }

      return false;
    }
  },
};
</script>

<style scoped></style>
